<template>
  <div style="padding: 10px;height: 100%" ref="materialBox">
    <div style="height: 30px;border-bottom: 1px solid #eee;margin-bottom: 10px;">
      <h3 style="font-size: 14px;font-weight:normal;display: inline-block;">{{nutSelect.nutritionName}}</h3>
      <a-icon type="close" @click="closeBox" style="float: right;font-size: 20px;" />
    </div>
    <a-row type="flex" align="middle" justify="space-between" style="padding-bottom:10px;">
      <div>
        <a-input-search :allowClear="true" size="small" v-model="keyword" placeholder="输入名称/代码" style="width:180px;margin-right: 10px;" @search="e => onSearch(e,'keyword')" />
        <a-input-search v-if="overseasFlag == '1'" :allowClear="true" size="small" v-model="aliasName" style="width:180px" placeholder="请输入原料别名" @search="e => onSearch(e,'aliasName')"/>
      </div>
      <base-list-select style="width:300px" category="raw" placeholder="选择类型" @change="typeChange" :value="types" />
    </a-row>
    <a-table
      :columns="columns"
      :data-source="list.records"
      :row-key="(record,index )=> index"
      :scroll="{x:leftWidth>1300?leftWidth:1300,y }"
      :pagination="false"
      :loading="listLoading">
      <a-tooltip slot="name" slot-scope="text,record">
        <template slot="title">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
        <span class="nameStyle">{{overseasFlag == '1' ? (record.aliasName || text) : text}}</span>
      </a-tooltip>
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 原料名称</span>
      <template
        slot="nutritionValue"
        slot-scope="text">
        {{ text === '' || text === null ? text : Number(text).toFixed(4)}}
      </template>
      <template
        v-for="col in ['percentage','content']"
        :slot="col"
        slot-scope="text">
        {{ text === '' || text === null ? text : Number(text).toFixed(3)}}
      </template>
      <template slot="contentPercentage" slot-scope="text">
        {{ text === '' || text === null ? text : Number(text * 100).toFixed(3)}}
      </template>
    </a-table>
  </div>
</template>
<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'

export default {
  components: { BaseListSelect },
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      columns:[
        {
          dataIndex:'name',
          // title:'原料名称',
          width: 160,
          scopedSlots: {customRender: 'name'},
          fixed: 'left',
          slots: { title: 'customTitle' },
        },
        {
          dataIndex:'code',
          title:'代码',
          // width:95
        },
        {
          dataIndex:'typeName',
          title:'原料类型',
          // width:150
        },
        {
          dataIndex:'percentage',
          title:'用量(%)',
          scopedSlots: {customRender: 'percentage'},
          sorter: (a, b) => a.percentage - b.percentage,
          sortDirections: ['descend', 'ascend'],
          align:'center',
          // width:100
        },
        {
          dataIndex:'nutritionValue',
          scopedSlots: {customRender: 'nutritionValue'},
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
          sortDirections: ['descend', 'ascend'],
          title:'数值',
          align:'center',
          // width:100
        },
        {
          dataIndex:'content',
          scopedSlots: {customRender: 'content'},
          sorter: (a, b) => a.content - b.content,
          sortDirections: ['descend', 'ascend'],
          title:'养分贡献值',
          align:'center',
          // width:100
        },
        {
          dataIndex:'contentPercentage',
          scopedSlots: {customRender: 'contentPercentage'},
          sorter: (a, b) => a.contentPercentage - b.contentPercentage,
          sortDirections: ['descend', 'ascend'],
          title:'养分贡献值(%)',
          align:'center',
          // width:100
        }
      ],
      keyword:'',
      aliasName: '',
      types:[],
      listLoading:false,
      equation:{
        records:[]
      },
      y: 500,
      filled: true
    }
  },
  mounted(){
    // this.getEquationList()
    this.getList()
    this.y = this.$refs.materialBox.offsetHeight - 116
  },
  watch:{
    nutSelect(val){
      if(val && val.nutritionId) {
        this.types = []
        this.keyword = ''
        this.aliasName = ''
        this.$nextTick(()=>{
          this.getList({nutritionId:val.nutritionId})
        })
      }
    }
  },
  computed:{
    title(){
      return this.nutSelect ? this.nutSelect.nutritionName : ''
    }
  },
  methods:{
    changeColumns(){
      let columns = [...this.columns]
      if(this.filled){
        columns[0].fixed = 'left'
      }else{
        delete columns[0].fixed
      }
      this.columns = columns
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns()
      e = e || window.event;
      if(e.stopPropagation) { //W3C阻止冒泡方法
          e.stopPropagation();
      } else {
          e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    resetList(){
      this.setState({nutSelect:{}})
      this.list.records = []
    },
    closeBox(){
      this.setState({nutVisible: false})
    },
    itemChange(value, id, column) {
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      if (target) {
        target[column] = value
        this.list.records = newData
      }
    },

    eidtorItem(id){
      this.cacheData = [...this.list.records]
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },

    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.id)[0]
      const targetCache = newCacheData.filter(item => key === item.id)[0]
      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
    },
    cancel(){
      this.types = []
      this.keyword = ''
      this.aliasName = ''
      this.toggleVisible('nut')
    },
    cancelHandle(id){
      let newData = [...this.list.records]
      let target = newData.filter(item => id === item.id)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false
        this.list.records = newData
      }
    },

    onSearch(val,field){
      this.getList({
        [field]: val
      })
    },

    typeChange(val = []){
      this.types = val
      if(val && val.length){
        const typeId = [...val].pop()
        this.getList({ typeId })
      }else{
        this.getList()
      }
    },

    getEquationList(){
      this.fetchGet({
        actions:this.equationList,
        name:'equation',
        data:{
          size:200
        }
      })
    },

    async getList(arg= {}){
      const params = {
        nutritionId:this.nutSelect.nutritionId,
        formulaId:this.formulaId
      }
      if(this.types.length) params.typeId=[...this.types].pop()
      if(this.keyword) params.keyword = this.keyword
      if(this.aliasName) params.aliasName = this.aliasName
      let func = [this.selectFormulaMixNutritionToRawPage,this.selectFormulaNutritionToRawPage]
      await this.fetchGet({
        actions: func[this.nutSelect.tabKey - 1],
        isList:true,
        loading:'listLoading',
        name:'list',
        data:{
          ...params,
          ...arg,
          factoryId:window.localStorage.getItem('factoryId'),
          size:1200,
        },
      })
      // 手动排序
      this.sortData('content', 'descend')
      console.log(this.list.records)
    },
    sortData(column, order) {
      this.list.records.sort((a, b) => {
        if (order === 'ascend') {
          return a[column] - b[column];
        } else {
          return b[column] - a[column];
        }
      });
    }
  }
}
</script>
